<pr-input-abstract
  [control]="control"
  label="Propriétaire"
  [derrors]="derrors"
  [tooltipButton]="tooltipButton ? tooltipButton : null"
>
  <mat-select
    (selectionChange)="onInputChange($event)"
    [(value)]="values"
    [compareWith]="compareFn"
    [disabled]="disabled"
  >
    @for (option of options; track option) {
      <mat-option [value]="option.ids">
        {{ option.label }}
      </mat-option>
    }
  </mat-select>
</pr-input-abstract>
